import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, message, Popconfirm, Space, Table, Tag } from "antd";
import {
  useDeleteDeveloperPortalPersonalAccessTokenMutation,
  useGetDeveloperPortalPersonalAccessTokensQuery,
} from "features/personalAccessTokensTable/personalAccessTokensAPI";
import { useState } from "react";
import moment from "moment-timezone";
import CreatePersonalAccessTokenModal from "features/personalAccessTokensTable/components/createPersonalAccessTokenModal";
import styled from "styled-components";

const StyledFlex = styled(Flex)`
  margin-bottom: 12px;
  margin-top: 12px;
`;

const StyledH3 = styled.h3`
  margin-top: 0;
  margin-bottom: 0;
`;

function PersonalAccessTokensTable() {
  const [isCreatePersonalAccessTokenModalVisible, setCreatePersonalAccessTokenModalVisible] =
    useState(false);
  const { data: personalAccessTokens, isLoading: isPersonalAccessTokensLoading } =
    useGetDeveloperPortalPersonalAccessTokensQuery();
  const [deleteDeveloperPortalPersonalAccessToken] =
    useDeleteDeveloperPortalPersonalAccessTokenMutation();

  const handleDelete = async (payload) => {
    await deleteDeveloperPortalPersonalAccessToken(payload);
    message.success("Personal Access Token removed successfully!");
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Expiration",
      dataIndex: "expiresAt",
      key: "expiresAt",
      render: (text) => (
        <Space>
          <span>{text || "Never"}</span>
          {!text || moment(text).isAfter(moment()) ? (
            <Tag color="success">Active</Tag>
          ) : (
            <Tag color="error">Expired</Tag>
          )}
        </Space>
      ),
    },
    {
      title: "Last Used",
      dataIndex: "lastUsedAt",
      key: "lastUsedAt",
      render: (text) => (text ? moment(text).fromNow() : "Never"),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => {
        return (
          <Popconfirm
            placement="topLeft"
            okText="Yes"
            title="Are you sure you want to delete this Personal Access Token?"
            onConfirm={() =>
              handleDelete({
                id: record.id,
              })
            }
          >
            <DeleteOutlined key="delete" />
          </Popconfirm>
        );
      },
    },
  ];

  return (
    <>
      <StyledFlex align="center">
        <StyledH3>Personal Access Tokens</StyledH3>
        <Button
          type="link"
          onClick={() => setCreatePersonalAccessTokenModalVisible(true)}
          icon={<PlusOutlined />}
        >
          Add Personal Access Token
        </Button>
      </StyledFlex>
      <Table
        bordered
        loading={isPersonalAccessTokensLoading}
        // @ts-ignore
        columns={columns}
        dataSource={personalAccessTokens}
        scroll={{ x: "max-content" }}
      />
      <CreatePersonalAccessTokenModal
        title="Add Personal Access Token"
        open={isCreatePersonalAccessTokenModalVisible}
        onOk={() => setCreatePersonalAccessTokenModalVisible(false)}
        onCancel={() => setCreatePersonalAccessTokenModalVisible(false)}
      />
    </>
  );
}

export default PersonalAccessTokensTable;
